// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
var record = function (value) {
    return value !== null && typeof value === "object" ? value : {};
};
/** Recognize only our trigger refusals, preserving unrelated permission errors. */
export var getTrustedWriteErrorMessage = function (error) {
    var outer = record(error);
    var body = record(outer.body);
    var source = Array.isArray(outer.graphQLErrors) ? outer : body;
    var errors = Array.isArray(source.graphQLErrors) ? source.graphQLErrors : [];
    var messages = [outer.message];
    for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
        var entry = errors_1[_i];
        var item = record(entry);
        messages.push(item.message);
        messages.push(record(record(record(item.extensions).internal).error).message);
    }
    for (var _a = 0, messages_1 = messages; _a < messages_1.length; _a++) {
        var message = messages_1[_a];
        if (typeof message !== "string")
            continue;
        if (message.includes("can only change through the voting status actions")) {
            return "Voting state changed or cannot be saved directly. Reload, then use the Publish tab or a scheduled event to open, pause or close voting.";
        }
        if (message.includes("can only change through a scheduled lockdown event")) {
            return "Lockdown state changed or cannot be saved directly. Reload, then schedule a start or end of the lockdown period.";
        }
        if (message.includes("Initialization report state can only change through report generation")) {
            return "Initialization state cannot be saved directly. Reload, then generate the initialization report from the Publish tab.";
        }
        if (message.includes("Scheduled execution and prediction results can only be written by the scheduler")) {
            return "Scheduled results changed since this form was loaded. Reload before saving; execution results and predictions are read-only.";
        }
        if (message.includes("grace period") &&
            message.includes("can only change before voting starts")) {
            return "The grace period cannot change after voting has started. Reload to restore the saved settings.";
        }
    }
    return undefined;
};
/** ra-data-graphql retains Apollo errors in HttpError.body. */
export var rethrowTrustedWriteError = function (error) {
    var message = getTrustedWriteErrorMessage(error);
    if (message)
        throw new Error(message);
    throw error;
};
